/* BusinessBulk bulk pricing controller.

   HISTORY / WHY THIS FILE EXISTS
   The first version resolved the product form with:
       querySelectorAll('form[action*="/cart/add"]')  -> first one with [name="id"]
   On Dawn that is WRONG. Shopify renders a Shop Pay *installment* form that
   also posts to /cart/add and also carries a [name="id"] input, and it appears
   BEFORE the real add-to-cart form in the DOM. So every variant switch and every
   line item property was written into a form that is never submitted, while the
   real form kept its server-rendered default variant (tier 1, single sided) and
   no properties. The page showed the right price; the cart charged the default.

   The real form is always the one inside <product-form>, i.e.
   form[data-type="add-to-cart-form"]. Never match .installment.

   V2 (per color / per shape SKUs)
   sections/bb-bulk-options.liquid finds the options by name and renders
   data-i-tier / data-i-side / data-i-color / data-i-shape / data-i-combo on the
   root, plus the variant list in [data-bb-variants].
   - Products with a Color, Shape or combined "Color and Shape" option: the id
     sent to /cart/add is the variant matching tier (from quantity) + side +
     Color + Shape (combined value = Color + data-combo-sep + Shape). If a
     choice is missing, or the combination has no available variant, add to
     cart is blocked.
   - Every other product (legacy) never enters the resolver and keeps the
     v1 behaviour: the tier row ids decide the variant.
   - The capture phase submit guard fails CLOSED: any exception while checking
     blocks the submit and shows an error, so Dawn never adds an unchecked id.

   Q4
   - ?variant=<id> landing: the section preselects the Color / Shape / Side
     dropdowns from product.selected_variant and puts its id and tier value on
     the root (data-pre-variant / data-pre-tier). After mount, on products that
     use the resolver, the quantity is seeded with that tier's minimum (only
     raised, never lowered) and update() re-resolves, so the form id, summary
     price and tier highlight all agree with the preselected choices.
   - Line item properties: a Color / Shape dropdown is written as
     properties[Color] / properties[Shape] ONLY when the product has no option
     carrying that choice. On converted products the variant's own option value
     already names it, and writing the property too printed "Color: DARK BROWN"
     twice on the cart, order emails and packing slips. The coaster bottle
     opener (Color option, Shape metafield only) keeps Shape as a property; a
     product with no Color / Shape option keeps both. Other properties on the
     form (e.g. Upload-Lift's upload_1) are never touched.
*/
(function () {
  var root = document.querySelector('[data-bb-bulk]');
  if (!root) { console.log('[bb-bulk] root not found'); return; }
  var hasSide = root.getAttribute('data-has-side') === 'true';

  var FATAL_TEXT = 'Something went wrong. Please refresh the page and try again.';

  function money(n) { return '$' + n.toFixed(2); }

  function isInstallment(f) {
    return /installment|payment-terms/i.test(f.className || '') || f.id === 'product-form-installment';
  }

  // The real add-to-cart form, never the installment form.
  function findForm() {
    var f = document.querySelector('product-form form[action*="/cart/add"]');
    if (f) return f;
    f = document.querySelector('form[data-type="add-to-cart-form"]');
    if (f) return f;
    var all = [].slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    for (var i = 0; i < all.length; i++) if (!isInstallment(all[i])) return all[i];
    return null;
  }

  function intAttr(name, fallback) {
    var raw = root.getAttribute(name);
    if (raw === null || raw === '') return fallback;
    var n = parseInt(raw, 10);
    return isNaN(n) ? fallback : n;
  }

  function mount() {
    var form = findForm();
    if (!form) return false;

    // Every element and state variable used by update() and the submit guard
    // is declared here, before the guard is attached.
    var ready = false;
    var rows = [];
    var tiers = [];
    var sideSel = null;
    var qtyInput = null;
    var calcEl = null;
    var totalEl = null;
    var nextEl = null;
    var props = [];
    var err = null;
    var unavailEl = null;
    var variantsEl = null;
    var variants = [];
    var idx = { tier: 0, side: -1, color: -1, shape: -1, combo: -1 };
    var SEP = ' - ';
    var usesVariantChoice = false;

    function productFormEl() {
      var el = form.parentNode;
      while (el && el.tagName !== 'PRODUCT-FORM') el = el.parentNode;
      return el || null;
    }

    // Visible error for the fail-closed paths. Uses Dawn's own product form
    // error line when present, otherwise the bb-bulk error line.
    function showFatal() {
      var pf = productFormEl();
      var wrap = pf ? pf.querySelector('.product-form__error-message-wrapper') : null;
      var msg = wrap ? wrap.querySelector('.product-form__error-message') : null;
      if (wrap && msg) {
        msg.textContent = FATAL_TEXT;
        wrap.hidden = false;
        return;
      }
      if (err) err.hidden = false;
    }

    // Capture phase: runs before Dawn's own submit handler builds its FormData,
    // so the variant id and properties are re-asserted at the last possible moment.
    // Attached first, so a failure anywhere below still leaves add to cart guarded.
    form.addEventListener('submit', function (e) {
      var block = false;
      var fatal = false;
      try {
        if (!ready) throw new Error('bb-bulk did not finish loading');
        update();
        syncProps();
        var missing = false;
        props.forEach(function (sel) { if (!sel.value) { sel.classList.add('is-invalid'); missing = true; } });
        if (missing) {
          block = true;
          if (err) err.hidden = false;
        } else if (usesVariantChoice) {
          if (!variants.length) throw new Error('variant data missing');
          var fin = resolveVariant(tierFor(currentQty()), isDouble());
          if (!fin.complete) throw new Error('a required choice has no dropdown');
          if (!fin.variant) {
            block = true;
            if (unavailEl) unavailEl.hidden = false; else if (err) err.hidden = false;
          } else {
            var idInput = form.querySelector('[name="id"]');
            if (!idInput || idInput.disabled || String(idInput.value) !== String(fin.variant.id)) {
              throw new Error('form variant id does not match the chosen options');
            }
          }
        }
      } catch (ex) {
        block = true;
        fatal = true;
        try { console.error('[bb-bulk] add to cart blocked', ex); } catch (ignore) {}
      }
      if (block) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (fatal) { try { showFatal(); } catch (ignore) {} }
        try { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (ignore) {}
      }
    }, true);

    function isDouble() { return hasSide && sideSel && sideSel.value === 'Double Sided'; }

    function tierFor(q) {
      for (var i = 0; i < tiers.length; i++) if (q >= tiers[i].min && q <= tiers[i].max) return tiers[i];
      return tiers[tiers.length - 1];
    }

    function currentQty() {
      var q = parseInt(qtyInput && qtyInput.value, 10);
      return (!q || q < 1) ? 1 : q;
    }

    function propValue(name) {
      for (var i = 0; i < props.length; i++) {
        if (props[i].getAttribute('data-bb-prop') === name) return props[i].value || '';
      }
      return '';
    }

    // True when a product option already carries this dropdown's choice, so
    // the variant names it and no line item property must be written.
    function choiceIsOption(name) {
      if (name === 'Color') return idx.color >= 0 || idx.combo >= 0;
      if (name === 'Shape') return idx.shape >= 0 || idx.combo >= 0;
      return false;
    }

    // Resolve the variant for tier t + side + the Color / Shape dropdowns.
    // Returns { variant, complete }:
    //   complete=false  a required Color / Shape is not chosen yet (variant is
    //                   then only a same tier + side placeholder for the price)
    //   complete=true, variant=null  the chosen combination does not exist
    // Only called when usesVariantChoice is true.
    function resolveVariant(t, dbl) {
      var want = [];
      var complete = true;
      function need(i, val) {
        if (i < 0) return;
        if (!val) { complete = false; return; }
        want.push([i, val]);
      }
      if (idx.tier >= 0) want.push([idx.tier, t ? t.label : '']);
      if (hasSide && idx.side >= 0) want.push([idx.side, dbl ? 'Double Sided' : 'Single Sided']);
      need(idx.color, propValue('Color'));
      need(idx.shape, propValue('Shape'));
      if (idx.combo >= 0) {
        var c = propValue('Color');
        var s = propValue('Shape');
        need(idx.combo, (c && s) ? c + SEP + s : '');
      }
      var match = null;
      for (var i = 0; i < variants.length && !match; i++) {
        var v = variants[i];
        var ok = v.available;
        for (var j = 0; j < want.length && ok; j++) if (v.o[want[j][0]] !== want[j][1]) ok = false;
        if (ok) match = v;
      }
      return { variant: match, complete: complete };
    }

    // Converted products only: show the "not available" line, and keep any
    // accelerated checkout button hidden until the order is fully specified.
    function gate(res) {
      if (!usesVariantChoice) return;
      var impossible = !!(res && res.complete && !res.variant && variants.length);
      if (unavailEl) unavailEl.hidden = !impossible;
      var propsMissing = props.some(function (s2) { return !s2.value; });
      var pay = form.querySelector('.shopify-payment-button');
      if (pay) pay.style.display = (propsMissing || !res || !res.complete || !res.variant) ? 'none' : '';
    }

    // Write the chosen variant into the real form. Also mirror it into the
    // installment form so the Shop Pay estimate matches what is being bought.
    function setVariant(id) {
      var forms = [].slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
      if (forms.indexOf(form) < 0) forms.push(form);
      forms.forEach(function (fm) {
        var input = fm.querySelector('[name="id"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'id';
          fm.appendChild(input);
        }
        input.disabled = false;
        input.value = id;
      });
    }

    function paintThemePrice(p) {
      var el = document.querySelector('.price__regular .price-item--regular, .price .price-item--regular, .price__container .price-item');
      if (el) el.textContent = money(p) + ' each';
    }

    function update() {
      var q = currentQty();
      var t = tierFor(q);
      var dbl = isDouble();
      var res = usesVariantChoice ? resolveVariant(t, dbl) : null;
      var unit = (res && res.variant) ? res.variant.price : (dbl ? t.p2 : t.p1);

      rows.forEach(function (r) { r.classList.remove('is-active'); });
      t.row.classList.add('is-active');

      if (hasSide) {
        rows.forEach(function (r) {
          var c = r.children;
          if (c.length >= 3) {
            c[1].classList.toggle('is-dim', dbl);
            c[2].classList.toggle('is-dim', !dbl);
          }
        });
      }

      calcEl.textContent = q + ' x ' + money(unit) + ' each' + (hasSide ? (dbl ? ' (double sided)' : ' (single sided)') : '');
      totalEl.textContent = money(q * unit);

      var nxt = tiers[tiers.indexOf(t) + 1];
      if (nxt && nxt.min - q > 0 && nxt.min - q <= 5) {
        var nres = usesVariantChoice ? resolveVariant(nxt, dbl) : null;
        var np = (nres && nres.variant) ? nres.variant.price : (dbl ? nxt.p2 : nxt.p1);
        nextEl.hidden = false;
        nextEl.textContent = 'Add ' + (nxt.min - q) + ' more to reach ' + money(np) + ' each (' + nxt.min + ' for ' + money(nxt.min * np) + ').';
      } else { nextEl.hidden = true; }

      setVariant((res && res.variant) ? res.variant.id : (dbl ? t.id2 : t.id1));
      paintThemePrice(unit);
      gate(res);
    }

    // update() for event handlers: an exception is logged and shown, never
    // thrown. The submit guard re-runs update() and blocks if it still fails.
    function safeUpdate() {
      try {
        update();
      } catch (ex) {
        try { console.error('[bb-bulk] update failed', ex); } catch (ignore) {}
        try { showFatal(); } catch (ignore2) {}
      }
    }

    // Dropdown -> line item property on the REAL form, only for a choice that
    // no product option carries (see the Q4 note in the header). A hidden
    // property input for a choice the variant already names is removed, so
    // the cart never shows it twice. Nothing else on the form is touched.
    function syncProps() {
      props.forEach(function (sel) {
        var n = sel.getAttribute('data-bb-prop');
        var hid = form.querySelector('input[data-bb-hidden="' + n + '"]');
        if (choiceIsOption(n)) {
          if (hid && hid.parentNode) hid.parentNode.removeChild(hid);
        } else {
          if (!hid) {
            hid = document.createElement('input');
            hid.type = 'hidden';
            hid.name = 'properties[' + n + ']';
            hid.setAttribute('data-bb-hidden', n);
            form.appendChild(hid);
          }
          hid.value = sel.value;
        }
        if (sel.value) { sel.classList.remove('is-invalid'); if (err) err.hidden = true; }
      });
    }

    try {
      try {
        var qw = document.querySelector('.product-form__quantity, .quantity-wrapper, .product-form__input--quantity');
        var anchor = document.querySelector('.product__info-container') || document.querySelector('.product__info-wrapper');
        if (qw && qw.parentNode) qw.parentNode.insertBefore(root, qw);
        else if (anchor) anchor.insertBefore(root, form);
      } catch (e) { console.log('[bb-bulk] move failed', e); }

      rows = [].slice.call(root.querySelectorAll('[data-bb-tier]'));
      tiers = rows.map(function (r) {
        return {
          row: r,
          min: parseInt(r.getAttribute('data-min'), 10),
          max: parseInt(r.getAttribute('data-max'), 10),
          p1: parseFloat(r.getAttribute('data-price')),
          p2: parseFloat(r.getAttribute('data-price2')) || 0,
          id1: r.getAttribute('data-variant-id'),
          id2: r.getAttribute('data-variant-id2'),
          label: r.getAttribute('data-tier') || ''
        };
      });

      sideSel = root.querySelector('[data-bb-side]');
      qtyInput = document.querySelector('.quantity__input') || form.querySelector('[name="quantity"]');
      calcEl = root.querySelector('[data-bb-calc]');
      totalEl = root.querySelector('[data-bb-total]');
      nextEl = root.querySelector('[data-bb-next]');

      // Color / Shape dropdowns. They pick the variant on converted products
      // and travel as line item properties only where no option carries them.
      props = [].slice.call(root.querySelectorAll('[data-bb-prop]'));
      err = root.querySelector('[data-bb-error]');
      unavailEl = root.querySelector('[data-bb-unavailable]');
      variantsEl = root.querySelector('[data-bb-variants]');

      idx = {
        tier: intAttr('data-i-tier', 0),
        side: intAttr('data-i-side', -1),
        color: intAttr('data-i-color', -1),
        shape: intAttr('data-i-shape', -1),
        combo: intAttr('data-i-combo', -1)
      };
      SEP = root.getAttribute('data-combo-sep') || ' - ';
      // Legacy products (no Color / Shape / combined option) never enter the resolver.
      usesVariantChoice = idx.color >= 0 || idx.shape >= 0 || idx.combo >= 0;

      variants = [];
      if (usesVariantChoice) {
        try {
          var parsed = JSON.parse(variantsEl ? variantsEl.textContent : '');
          if (!Array.isArray(parsed)) throw new Error('variant data is not a list');
          parsed.forEach(function (a) {
            if (!Array.isArray(a) || !Array.isArray(a[1])) return;
            variants.push({ id: String(a[0]), o: a[1], price: Number(a[2]) / 100, sku: a[3], available: a[4] !== false });
          });
        } catch (ex) {
          console.error('[bb-bulk] variant data unreadable, add to cart is blocked', ex);
          variants = [];
        }
      }

      console.log('[bb-bulk] mounted v2. form=' + (form.getAttribute('id') || form.className) +
        ' installment=' + isInstallment(form) + ' tiers=' + tiers.length +
        ' side=' + hasSide + ' qty=' + !!qtyInput +
        ' choice=' + usesVariantChoice + (usesVariantChoice ? ' variants=' + variants.length : ''));

      if (qtyInput) ['input', 'change', 'keyup'].forEach(function (ev) { qtyInput.addEventListener(ev, safeUpdate); });
      if (sideSel) sideSel.addEventListener('change', safeUpdate);

      rows.forEach(function (r) {
        r.addEventListener('click', function () {
          if (qtyInput) {
            qtyInput.value = parseInt(r.getAttribute('data-min'), 10);
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          safeUpdate();
        });
      });

      props.forEach(function (sel) {
        sel.addEventListener('change', function () {
          syncProps();
          // A new Color / Shape is a new variant on converted products.
          if (usesVariantChoice) safeUpdate();
        });
      });
      syncProps();
      ready = true;
    } catch (ex) {
      // Setup failed: the guard above stays attached and blocks every submit.
      try { console.error('[bb-bulk] mount failed, add to cart is blocked', ex); } catch (ignore) {}
      try { showFatal(); } catch (ignore2) {}
      return true;
    }

    // ?variant= landing (converted products only). The section already
    // preselected the dropdowns; here the quantity is raised to the minimum of
    // that variant's tier so update() below resolves to the exact variant the
    // link named. Never lowers a quantity, never touches legacy products, and
    // a failure here only logs: the submit guard still decides what is added.
    var pre = null;
    try {
      var preId = usesVariantChoice ? (root.getAttribute('data-pre-variant') || '') : '';
      if (preId) {
        var preTier = root.getAttribute('data-pre-tier') || '';
        var preRow = null;
        for (var pi = 0; pi < tiers.length; pi++) if (tiers[pi].label === preTier) preRow = tiers[pi];
        if (preRow && qtyInput && currentQty() < preRow.min) {
          qtyInput.value = preRow.min;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        pre = { id: preId, tier: preTier, row: !!preRow };
      }
    } catch (ex) {
      try { console.log('[bb-bulk] preselect failed', ex); } catch (ignore) {}
    }

    // Proof / upload guidance sits immediately before the uploader app,
    // falling back to just above Add to Cart. The app's markup is not touched.
    // Cosmetic only, so a failure here never blocks add to cart.
    try {
      var proof = document.querySelector('[data-bb-proof]');
      if (proof) {
        var scope = document.querySelector('.product__info-container') || form;
        var best = null;
        var candidates = scope.querySelectorAll('div, section, aside');
        for (var ci = 0; ci < candidates.length; ci++) {
          var txt = (candidates[ci].textContent || '').trim();
          if (txt.length < 140 && /drag\s*&\s*drop|drag and drop|browse/i.test(txt)) best = candidates[ci];
        }
        var target = best || form.querySelector('[name="add"]');
        if (target && target.parentNode) target.parentNode.insertBefore(proof, target);
        proof.hidden = false;

        var pre2 = proof.querySelector('[data-bb-preselect]');
        var note = proof.querySelector('[data-bb-uploadnote]');
        var syncPre = function () {
          var missing2 = false;
          props.forEach(function (s2) { if (!s2.value) missing2 = true; });
          if (pre2) pre2.hidden = !missing2;
          if (note) note.hidden = missing2;
        };
        props.forEach(function (s2) { s2.addEventListener('change', syncPre); });
        syncPre();
      }
    } catch (ex) {
      try { console.log('[bb-bulk] proof block failed', ex); } catch (ignore) {}
    }

    safeUpdate();
    if (pre) {
      try {
        var preInput = form.querySelector('[name="id"]');
        var preNow = preInput ? String(preInput.value) : '';
        console.log('[bb-bulk] preselect variant=' + pre.id + ' tier="' + pre.tier + '" row=' + pre.row +
          ' qty=' + currentQty() + ' form=' + preNow + (preNow === String(pre.id) ? ' match' : ' MISMATCH'));
      } catch (ignore) {}
    }
    return true;
  }

  if (!mount()) {
    var n = 0;
    var iv = setInterval(function () { if (mount() || ++n > 40) clearInterval(iv); }, 150);
  }
})();
